import React from 'react';
import clsx from 'clsx';
import {
  Info as InfoIcon,
  Zap as ZapIcon,
  Layers as LayersIcon,
  CheckCircle as CheckCircleIcon,
} from 'react-feather';
import { createStyles, makeStyles } from '@material-ui/styles';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Category, Severity } from '@jupiterone/notification-types';

const ICON_SIZE = '25px';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    // Root app menu component applies styles to all SVGs
    // Have to override here
    root: {
      margin: '0 !important',
      width: `${ICON_SIZE} !important`,
      height: `${ICON_SIZE} !important`,
    },
    [Severity.INFORMATIONAL]: {
      color: theme.palette.info.main,
    },
    [Severity.WARNING]: {
      color: theme.palette.warning.main,
    },
    [Severity.ERROR]: {
      color: theme.palette.error.main,
    },
  })
);
const getCategoryIcon = (category?: Category) => {
  switch (category) {
    case Category.INTEGRATIONS: {
      return ZapIcon;
    }
    case Category.COMPLIANCE: {
      return CheckCircleIcon;
    }
    case Category.POLICIES: {
      return LayersIcon;
    }
    default: {
      return InfoIcon;
    }
  }
};

interface NotificationIconProps {
  category?: Category;
  severity?: Severity;
  className?: string;
}
const NotificationIcon = ({
  category,
  severity = Severity.INFORMATIONAL,
  className,
}: NotificationIconProps) => {
  const classes = useStyles();
  const IconComponent = getCategoryIcon(category);
  return (
    <IconComponent
      className={clsx(classes.root, className, classes[severity])}
    />
  );
};

export default NotificationIcon;
